/** Minimalni DOM pomočniki. Nič, kar bi bilo framework. */

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: (Node | string)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) node.setAttribute(name, value);
  node.append(...children);
  return node;
}

const SPRITE = 'ds/brand/icons/nesylab-icons-sprite.svg';
const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Ikone so stroke-only, 24×24, currentColor (T5 §8).
 * Nikoli ne mešaj s polnimi ikonami — sistem je stroke-only.
 */
export function icon(id: string, size = 24): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('class', 'icon');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('aria-hidden', 'true');

  const use = document.createElementNS(SVG_NS, 'use');
  use.setAttribute('href', `${SPRITE}#${id}`);
  svg.append(use);
  return svg;
}

export function clear(node: Element): void {
  node.replaceChildren();
}

export function must<T extends Element>(selector: string): T {
  const node = document.querySelector<T>(selector);
  if (node === null) throw new Error(`Manjka element: ${selector}`);
  return node;
}
